import React, { useEffect, useState } from "react";
import Hoc from "../HOC/Hoc";
import TopHeading from "../../utils/TopHeading/TopHeading";
import AnimatedPage from "../animatedPage/AnimatedPage";
import AsyncDropdown from "../../utils/asyncDropdown/AsyncDropdown";
import { updateManualPoints, getPointType } from "./ManualPoints-api";
import {
  Stack,
  TextField,
  Paper,
  Button,
  Grid,
  Snackbar,
  InputAdornment,
  Alert,
} from "@mui/material";

const pointsList = [
  { id: 1, value: "100" },
  { id: 2, value: "50" },
  { id: 3, value: "200" },
];

const ManualPointsPage = () => {
  const [panelist, setPanelist] = useState(null);
  const [surveyCode, setSurveyCode] = useState(null);
  const [panelistIds, setPanelistIds] = useState([]);
  const [panelistEmails, setPanelistEmails] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [catgoryItems, setCatgoryItems] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [selectedPoints, setSelectedPoints] = useState(pointsList[0]);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    getPointType()
      .then((res) => {
        const response = res?.data?.data;
        if (res.status === 200) {
          if (res?.data?.success) {
            setCatgoryItems([
              { pointTypeId: 0, pointType: "Select Category" },
              ...response,
            ]);
            setSelectedCategory({
              pointTypeId: 0,
              pointType: "Select Category",
            });
          }
        } else {
          showSnackbar("Failed to load categories", "error");
        }
      })
      .catch((err) => {
        showSnackbar("Failed to load categories", "error");
      });

    return () => {
      setCatgoryItems([]);
    };
  }, []);

  const handleSubmit = () => {
    if (selectedCategory?.pointTypeId === 0) {
      showSnackbar("Category is required.", "error");
      return;
    }
    const hasValidPanelistIds = panelistIds.length > 0;
    const hasValidEmails = panelistEmails.length > 0;

    const hasNoPanelists = !hasValidPanelistIds && !hasValidEmails && !panelist;
    const hasNoCategory = !selectedCategory;
    const hasNoPoints = !selectedPoints?.value;
    const hasNoSurveyId = selectedCategory?.pointTypeId === 17 && !surveyCode;
    if (hasNoPanelists || hasNoCategory || hasNoPoints || hasNoSurveyId) {
      showSnackbar("All fields are required.", "error");
      return;
    }
    const pointsValue = parseInt(selectedPoints?.value || "0");
    const body = {
      pointType: selectedCategory?.pointTypeId,
      panelists: {
        panelistId:
          selectedCategory?.pointTypeId === 17
            ? (panelistIds[0] ?? null)
            : panelistIds,
        email: panelistEmails,
      },
      points: pointsValue > 200 ? 200 : pointsValue,
      surveyCode: selectedCategory?.pointTypeId === 17 ? surveyCode : null,
    };

    updateManualPoints(body)
      .then((res) => {
        if (res?.status === 200) {
          if (res?.data?.success) {
            showSnackbar("Panelists upgraded successfully", "success");
          } else {
            showSnackbar(res?.data?.message, "error");
          }
        } else {
          showSnackbar("Something went wrong! Try again", "error");
        }
      })
      .catch((err) => {
        showSnackbar(
          err?.response?.data?.message || "Something went wrong! Try again",
          "error",
        );
      })
      .finally(() => {
        handleCleanUp();
      });
  };

  const handlePanelistChange = (e) => {
    let inputValue = e.target.value;

    if (selectedCategory?.pointTypeId === 17) {
      inputValue = inputValue.replace(/[^0-9]/g, "");
      setPanelist(inputValue);
      setPanelistIds(inputValue ? [Number(inputValue)] : []);
      setPanelistEmails([]);
      return;
    }
    setPanelist(inputValue);
    // Other categories — normal flow
    let values = inputValue
      .split(/[\n,\s]+/)
      .map((val) => val.trim())
      .filter(Boolean);
    let panelistIds = values
      .filter((val) => !isNaN(val) && val !== "")
      .map(Number);
    let emails = values.filter((val) => isNaN(val) && val.includes("@"));
    setPanelistIds(panelistIds);
    setPanelistEmails(emails);
  };

  const handleNumberInputChange = (setter) => (e) => {
    const value = e.target.value;
    setter(value);
  };

  const handleCleanUp = () => {
    setPanelist("");
    setPanelistIds([]);
    setPanelistEmails([]);
    setSurveyCode("");
    setSelectedCategory(catgoryItems[0]);
    setSelectedPoints(pointsList[0]);
  };
  const handleCategoryDropDownChange = (value) => {
    setSelectedCategory(value);
    if (value?.pointTypeId === 17) {
      setSelectedPoints({ id: null, value: "" });
    } else {
      setSelectedPoints(pointsList[0]);
    }
  };

  const handlePointsDropDownChange = (value) => {
    setSelectedPoints(value);
  };

  useEffect(() => {
    if (pointsList.length && !selectedPoints) {
      setSelectedPoints(pointsList[0]);
    }
  }, []);

  return (
    <>
      <AnimatedPage>
        <TopHeading showButton={false} heading="Add Manual Points" />
        <Paper sx={{ px: 2, mx: 2, mb: 1 }} elevation={2}>
          <Stack spacing={6} alignItems="center">
            <Grid
              sx={{ px: 2, py: 1, mx: 2 }}
              container
              className="prioritySurveyForm"
            >
              <Grid sx={{ py: 3 }} container alignItems="center">
                <Grid sx={{ mx: 1, py: 3 }} xs={12} sm={6} md={6}>
                  <AsyncDropdown
                    label={"Point Category"}
                    value={selectedCategory}
                    handleChange={(value) =>
                      handleCategoryDropDownChange(value)
                    }
                    objKey="pointType"
                    options={catgoryItems}
                  />
                </Grid>

                {selectedCategory?.pointTypeId === 17 ? (
                  <Grid item sx={{ mx: 1 }} xs={12} sm={6} md={6}>
                    <TextField
                      type="number"
                      value={selectedPoints.value}
                      fullWidth
                      label="Points"
                      multiline
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        if (value > 200) {
                          showSnackbar(
                            "The maximum number of points allowed is 200",
                            "error",
                          );
                        } else {
                          setSelectedPoints({ id: null, value });
                        }
                      }}
                      variant="outlined"
                    />
                  </Grid>
                ) : (
                  <Grid sx={{ mx: 1 }} xs={12} sm={6} md={6}>
                    <AsyncDropdown
                      label="Points"
                      value={selectedPoints}
                      handleChange={setSelectedPoints}
                      objKey="value"
                      options={pointsList}
                    />
                  </Grid>
                )}
              </Grid>
              <Grid container alignItems="center">
                {selectedCategory?.pointTypeId === 17 ? (
                  <Grid item sx={{ mx: 1 }} xs={12} sm={6} md={6}>
                    <TextField
                      type="number"
                      value={surveyCode || ""}
                      fullWidth
                      label="Survey Code"
                      multiline
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      onChange={handleNumberInputChange(setSurveyCode)}
                      variant="outlined"
                    />
                  </Grid>
                ) : null}

                <Grid item sx={{ mx: 1, py: 3 }} xs={12} sm={6} md={6}>
                  <TextField
                    type="text"
                    value={panelist || ""}
                    fullWidth
                    label="Panelists"
                    rows={5}
                    multiline
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "2px solid #f0f0f0",
                      },
                    }}
                    onChange={handlePanelistChange}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
              <Grid sx={{ py: 2 }} container alignItems="center">
                <Grid sx={{ mx: 1 }} xs={12} sm={2} md={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Stack>
        </Paper>
      </AnimatedPage>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        onClose={handleCloseSnackbar}
      >
        <Alert
          severity={
            snackbarSeverity === "success" ? undefined : snackbarSeverity
          }
          onClose={handleCloseSnackbar}
          sx={{
            width: "100%",
            backgroundColor:
              snackbarSeverity === "success" ? "#2196f3" : undefined, // Blue for success
            color: snackbarSeverity === "success" ? "#fff" : undefined, // White text for blue background
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export const ManualPoints = Hoc(ManualPointsPage, { name: "" });
